import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { AnimatePresence } from 'framer-motion';
import Voice2RXModalQueuePage from './VoiceToRxModal';
import { track } from '../../tracking';
import { getMActiveId } from '../../store/localstorage';
import { getItemFromMisc, MISC_KEYS } from '../../store/idbHandler';
import { GenieSettings } from '../../api/pushGenie';

export const v2RX_DismissialTimeCounter_LS = 'v2rxButtonDissmisalTimeline';
const ONE_HOUR = 60 * 60 * 1000;
const ONE_DAY = 24 * ONE_HOUR;
const delaySequenceMs = [ONE_DAY, 3 * ONE_DAY, 7 * ONE_DAY];
// as mentioned in changelog as well our TL is 1 day, 3 days, 7 days, (now 7 days continues forever)
interface BannerInfo {
    lastDismissedAt: number;
    currentDelayMs: number;
}

interface V2RxButtonQueuePageState {
    isButtonForV2RXVisible: boolean;
    isV2RXModalOpen: boolean;
    showVoiceToRxPopover: boolean;
}

export class V2RxButtonQueuePage extends React.Component<
    Record<string, never>,
    V2RxButtonQueuePageState
> {
    constructor(props: Record<string, never>) {
        super(props);
        this.state = {
            isButtonForV2RXVisible: false,
            isV2RXModalOpen: false,
            showVoiceToRxPopover: false,
        };

        this.closeV2rxButtonTimeBased = this.closeV2rxButtonTimeBased.bind(this);
        this.getNextDelayMs = this.getNextDelayMs.bind(this);
        this.toggleV2rxButtonInitiator = this.toggleV2rxButtonInitiator.bind(this);
    }

    componentDidMount(): void {
        const now = Date.now();
        const stored = localStorage.getItem(v2RX_DismissialTimeCounter_LS);

        this.setState({
            isV2RXModalOpen: Boolean(
                sessionStorage.getItem('openV2rxModalAgain_ReloadTriggedFromModal'),
            ),
        });
        if (stored) {
            const { lastDismissedAt, currentDelayMs }: BannerInfo = JSON.parse(stored);
            if (now - lastDismissedAt >= currentDelayMs) {
                this.setState({ isButtonForV2RXVisible: true });
            }
        } else {
            this.setState({ isButtonForV2RXVisible: true });
        }

        const myId = getMActiveId() || '';
        getItemFromMisc<GenieSettings>(myId, MISC_KEYS.settings).then((res) => {
            this.setState({ showVoiceToRxPopover: res.showVoiceToRxPopover });
        });
    }

    getNextDelayMs(currentDelay: number | undefined): number {
        if (!currentDelay || !delaySequenceMs.includes(currentDelay)) {
            return delaySequenceMs[0];
        }

        const index = delaySequenceMs.indexOf(currentDelay);
        if (index === delaySequenceMs.length - 1) {
            return delaySequenceMs[index]; // stay at 1 week forever after going throuh 1 day 3 days and 7 days, then 7 days that is 1 weeek is forever repeated
        }

        return delaySequenceMs[index + 1];
    }

    closeV2rxButtonTimeBased(): void {
        const now = Date.now();
        const stored = localStorage.getItem(v2RX_DismissialTimeCounter_LS);
        let currentDelayMs = delaySequenceMs[0];

        if (stored) {
            const parsed: BannerInfo = JSON.parse(stored);
            currentDelayMs = this.getNextDelayMs(parsed.currentDelayMs);
        }

        localStorage.setItem(
            v2RX_DismissialTimeCounter_LS,
            JSON.stringify({
                lastDismissedAt: now,
                currentDelayMs,
            }),
        );

        this.setState({ isButtonForV2RXVisible: false });
    }

    toggleV2RXModal = (): void => {
        track('CLICK_ON_V2RX_BUTTON');
        this.setState({ isV2RXModalOpen: true });
    };

    toggleV2rxButtonInitiator(e: React.MouseEvent) {
        e.stopPropagation();
        track('CLOSED_V2RX_BANNER_BUTTON');
        this.closeV2rxButtonTimeBased();
    }
    render(): React.ReactNode {
        if (!this.state.isButtonForV2RXVisible || !this.state.showVoiceToRxPopover) {
            return null;
        }

        return (
            <>
                <div onClick={this.toggleV2RXModal} className="AIFeaturesButtonContainer">
                    <div className="flex relative justify-end left-7 -top-7">
                        <div
                            className="absolute cursor-pointer bg-darwin-neutral-600 flex justify-center items-center w-16 h-16 rounded-full z-1"
                            onClick={this.toggleV2rxButtonInitiator}
                        >
                            <CloseOutlined className="text-white text-8" />
                        </div>
                    </div>
                    <button className="">
                        <div className="AIFeaturesGradientButton">
                            <div className="flex items-center gap-12">
                                <img src={'/images/v2rxIcon.svg'} alt="V2RX Button Icon" />
                                <span className="text-darwin-accent-bright-blue-800 text-13 font-700">
                                    Generate prescription from voice
                                </span>
                            </div>
                        </div>
                    </button>
                </div>

                <AnimatePresence>
                    <Voice2RXModalQueuePage
                        isOpen={this.state.isV2RXModalOpen}
                        onClose={() => {
                            sessionStorage.removeItem('openV2rxModalAgain_ReloadTriggedFromModal');
                            this.setState({
                                isV2RXModalOpen: false,
                            });
                        }}
                    />
                </AnimatePresence>
            </>
        );
    }
}
